import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {HiperioConfigDirect} from "../interface/hiperio-config-direct";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {first} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class HiperioConfigDirectService {

  public readonly hiperioConfigDirectListSubject: ReplaySubject<CountedAndPaginated<HiperioConfigDirect>>
    = new ReplaySubject<CountedAndPaginated<HiperioConfigDirect>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public getLst(
    page: number,
    pageSize: number,
    filters: object,
  ): void {
    this.httpClient.get(`/rest/crm/direct/hiperio-config-direct?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<HiperioConfigDirect>) => {
        this.hiperioConfigDirectListSubject.next(result);
      });
  }

  public get(id: string): Observable<HiperioConfigDirect> {
    return this.httpClient.get(`/rest/crm/direct/hiperio-config-direct/${id}`)
      .pipe(first()) as Observable<HiperioConfigDirect>;
  }

  public sendUpdateRegistration(param: {registration: any }, id: number): Observable<any> {
    return this.httpClient.put(`/rest/crm/direct/hiperio-config-direc-registration/${id}`, param);
  }
}
